module.exports = __webpack_public_path__ + "img/2d42159d39540e75a36ae583aa9d9b2d.b01ddd39.png";